import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.feature-sets.slack-user-linking-section`

export default defineMessages({
  syncUsersHeader: {
    id: `${scope}.syncUsersHeader`,
    defaultMessage: 'Link your team automatically',
  },
  syncUsersText: {
    id: `${scope}.syncUsersText`,
    defaultMessage:
      'We’ll help you get started by linking your Procurify users to Slack by email.',
  },
  syncButtonLabel: {
    id: `${scope}.syncButtonLabel`,
    defaultMessage: 'Link users',
  },
  linkUsersHeader: {
    id: `${scope}.linkUsersHeader`,
    defaultMessage: 'Link users manually',
  },
  linkUsersText: {
    id: `${scope}.linkUsersText`,
    defaultMessage:
      "If an email doesn’t match or a user isn't found, you can link them here. Search for a name to find their Slack account and finish the setup.",
  },
})
